/**
 * Import required libraries
 */
import React, {
  useEffect,
  useState
} from "react";
import {
  public as publicApi
} from "api";

/**
 * Import required elements
 */
import PlatformRender from "./render";

/**
 * Platform Component
 */
function Platform(props) {

  // Platform informations loaded {Boolean}
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    // api call to get platform informations (theme, logo, background, services, ...)
    const tryConnection = async (start = false) => {
      try {
        await publicApi()
        if (mounted) setLoaded(true);
      } catch (err) {
        if (start) console.error(err);
        setTimeout(() => {
          if (mounted) tryConnection();
        }, 50);
      }
    }
    tryConnection(true);
    return () => {
      if ("serviceWorker" in (globalThis.navigator || {})) {
        globalThis.navigator.serviceWorker.getRegistrations().then(registrations => {
          if (registrations.length) console.log(registrations.length, "serviceWorkers to unregister")
          return Promise.all(registrations.map(reg => reg.unregister())).then(() => {
            if (registrations.length) console.log(registrations.length, "serviceWorker unregistered")
          })
        })
      }
      mounted = false;
    }
  }, []);

  return React.createElement(PlatformRender, { loaded });
}

/**
 * Export component
 */
// map redux state to props
export default Platform;